import React, { useState } from 'react';
import axios from "axios";
import { Button, DatePicker, Drawer, Select } from "@opendate-app/setlist";

import { useBroadcastEditContext } from "./BroadcastEditContainer";
import { defaultPickedDayToNoon } from "./scheduleDate";

import { offsetDateFromTimeZone, offsetDateToTimezone } from "../../../shared/timeZoneLogic";
import { toastSuccess, toastError } from "../../../shared/toastHelper";

var moment = require('moment-timezone');

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  footer: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
};

const timeZones = moment.tz.names().map(tz => ({ value: tz, label: tz }));

const ScheduledSendPane = () => {
  const {
    csrfToken,
    team,
    broadcast,
    scheduledSend,
    setScheduledSend,
    scheduledSendPaneOpen,
    setScheduledSendPaneOpen,
    timeZone,
    setTimeZone,
    scheduledAt,
    setScheduledAt,
  } = useBroadcastEditContext();

  const [scheduledAtFormState, setScheduledAtFormState] = useState(scheduledAt);
  const [timeZoneFormState, setTimeZoneFormState] = useState(timeZone);

  const handleSubmit = (e) => {
    e.preventDefault();
    setScheduledSendPaneOpen(false);

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

    const axiosRequest = scheduledSend ?
      axios.put(`/teams/${team.id}/scheduled_sends/${scheduledSend.id}`, {
        scheduled_send: {
          scheduled_at: offsetDateFromTimeZone(scheduledAtFormState, timeZoneFormState)
        }
      }) :
      axios.post(`/teams/${team.id}/scheduled_sends`, {
        scheduled_send: {
          schedulable_id: broadcast.id,
          schedulable_type: "Broadcast",
          scheduled_at: offsetDateFromTimeZone(scheduledAtFormState, timeZoneFormState)
        }
      });

      axiosRequest
        .then(({ data }) => {
          setScheduledSend(data);
          setScheduledAt(offsetDateToTimezone(data.scheduled_at, timeZoneFormState));
          setTimeZone(timeZoneFormState);
          toastSuccess("Broadcast successfully scheduled");
        })
        .catch((error) => {
          setScheduledAtFormState(scheduledSend ? offsetDateToTimezone(scheduledSend.scheduled_at, timeZone) : null);
          setTimeZoneFormState(timeZone);
          const errors = error.response.data;
          toastError(errors.join(", "));
        });
  };

  const cancelScheduledSend = (e) => {
    e.preventDefault();
    setScheduledAt(null);
    setScheduledSendPaneOpen(false);

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.put(`/teams/${team.id}/scheduled_sends/${scheduledSend.id}/cancel`)
      .then(() => {
        window.location = `/teams/${team.id}/broadcasts/${broadcast.id}/edit?tab=review-and-schedule`;
      })
      .catch((error) => {
        const errors = error.response.data;
        toastError(errors.join(", "));
      });
  };

  const closePane = () => {
    setScheduledSendPaneOpen(false);
    setScheduledAtFormState(scheduledAt);
    setTimeZoneFormState(timeZone);
  };

  return (
    <Drawer
      backdrop
      closeOnEsc={false}
      open={scheduledSendPaneOpen}
      onClose={closePane}
      title="Schedule Broadcast"
      subtitle="When do you want to send this broadcast?"
      footer={(
        <div style={styles.footer}>
          <Button type="submit" form="scheduled-send-form" variant="primary" disabled={!scheduledAtFormState}>
            Schedule Broadcast
          </Button>
          {scheduledSend ? (
            <Button variant="link-destructive" onClick={cancelScheduledSend}>
              Cancel Send
            </Button>
          ) : null}
        </div>
      )}
    >
      <form id="scheduled-send-form" style={styles.form} onSubmit={handleSubmit}>
        <DatePicker
          time
          label="Date / Time"
          placeholder="Select date"
          min={moment().startOf("day").toDate()}
          value={scheduledAtFormState}
          onChange={date => setScheduledAtFormState(defaultPickedDayToNoon(scheduledAtFormState, date))}
        />
        <Select
          searchable
          label="Timezone"
          options={timeZones}
          value={timeZoneFormState}
          onChange={value => setTimeZoneFormState(value)}
        />
      </form>
    </Drawer>
  );
};

export default ScheduledSendPane;
